import axios from "axios";
import {
  authHeader,
  authHeaderWithMultipartData,
} from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API;

class AccountService {
  // payment method
  getPaymentMethodBrifList() {
    return axios
      .get(API_URL + "account/payment-method", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // add method
  addMethod(data) {
    return axios
      .post(API_URL + "account/payment-method", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // edit method
  editMethod(account_id, data) {
    return axios
      .patch(API_URL + "account/payment-method/" + account_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete method
  deleteMethod(account_id) {
    return axios
      .delete(API_URL + "account/payment-method/" + account_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // payment account
  getPaymentAccountBrifList(payment_method_id) {
    return axios
      .get(API_URL + "account/payment-account/" + payment_method_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // sub add method
  addAccount(payment_method_id, data) {
    return axios
      .post(API_URL + "account/payment-account/" + payment_method_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  sub edit method
  editAccount(payment_method_id, account_id, data) {
    return axios
      .patch(
        API_URL +
          "account/payment-account/" +
          payment_method_id +
          "/" +
          account_id,
        data,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete account
  deleteAccount(payment_method_id, account_id) {
    return axios
      .delete(
        API_URL +
          "account/payment-account/" +
          payment_method_id +
          "/" +
          account_id,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Payment method get
  getPaymentAccount() {
    return axios
      .get(API_URL + "account/payment-method-name", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Payment account based on payment account
  getPaymentChildAccount(payment_account_id) {
    return axios
      .get(API_URL + "account/payment-account-name/" + payment_account_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new AccountService();
